@if (isMenuVisible) {
  <mat-toolbar class="primary mat-elevation-z2" color="primary">
    <ng-content select="[navStart]" />
    <lfw-logo />
    <ng-content select="[navCenter]" />
    <span class="spacer"></span>
    <lfw-messages-button />
    @if (searchButtonVisible) {
      <button
        mat-icon-button
        [routerLink]="menuService.cmdSearch?.route"
        matTooltip="{{ showToolTip() ? ('SEARCH.SEARCH' | translate) : '' }}"
        routerLinkActive="active-link">
        <mat-icon>{{ menuService.cmdSearch?.icon }}</mat-icon>
      </button>
    }
    <ng-content select="[navEnd]" />
    @if (loading$ | async) {
      <mat-progress-bar mode="indeterminate" class="loadingbar" />
    }
  </mat-toolbar>
}
